module.exports = __webpack_public_path__ + "static/img-paralax-2-e85bc6487515dd240a2258c992613686.png";